import { Formik, FieldArray, Form } from "formik";
import React, { useRef, useState } from "react";
import * as Bootstrap from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import BotonTrash from "./BotonTrash";
import BotonAgregar from "./BotonAgregar";
import GrupoBotonesFlujo from "./GrupoBotonesFlujo";
import InputDescripcion from "./InputDescripcion";
import InputValoracion from "./InputValoracion";
import InputTalento from "./InputTalento";
import FormHeader from "./FormHeader";
import { updateMany } from "services";

import "react-toastify/dist/ReactToastify.css";
import { SetHasTalentsData } from "redux/actions/hasTalentsActions";
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { SetUser } from "redux/actions/userActions";

const TalentoForm = ({ personaTalentos: _personaTalentos, talentos, user, SetUser, SetOperationSuccess, SetHasTalentsData, opeationSuccess }) => {
  const formRef = useRef();
  const [isSending, setIsSending] = useState(false);
  const [guardarYContinuar, setguardarYContinuar] = useState(false)
  const history = useHistory()

  const notify = (text) =>
    toast.warn(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const validarTalentoUnico = (personaTalentos) => {
    const s = new Set();
    for (const talento of personaTalentos) {
      if (s.has(talento["talentoId"])) {
        notify(
          "No puede agregar el talento " +
          talentos.find(x => x.id == talento.talentoId).descripcion +
          " más de una vez"
        );
        return false
      }
      s.add(talento["talentoId"]);
    }
    return true
  }

  const validationSchema = Yup.object().shape({
    personaTalentos: Yup.array().of(
      Yup.object().shape({
        talentoId: Yup.number()
          .required("El talento es requerido")
          .moreThan(0, "El talento es requerido"),
        valoracion: Yup.number().required("La valoracion es requerida"),
        descripcion: Yup.string().required("La descripción es requerida"),
      })
    )
  });

  const refreshUser = (res) => {
    user.persona = {
      ...user.persona,
      personaTalentos: [...res.data]
    }
    SetUser(user);
    localStorage.setItem("currentUser-ARS", JSON.stringify(user));
  }

  const refreshHasTalentsData = (response) => {
    if (response && response.data && response.data.some((x) => x.estado == 1)) {
      SetHasTalentsData(true);
    } else {
      SetHasTalentsData(false);
    }
  }

  const obtenerTalentosInactivos = (personaTalentosForm) => {
    const talentosInactivos = _personaTalentos.filter((x) => !personaTalentosForm.some((y => y.id == x.id)));
    return talentosInactivos.map(talento => ({...talento, estado: 0}))
  }

  const onSubmit = async (values) => {
    const { personaTalentos: personaTalentosForm } = values;
    if (!validarTalentoUnico(personaTalentosForm)) return;
    const talentosInactivos = obtenerTalentosInactivos(personaTalentosForm)
    const personaTalentos = [...personaTalentosForm, ...talentosInactivos]
    
    setIsSending(true);
    try {
      const res = await updateMany("PersonaTalento", personaTalentos)
      refreshUser(res);
      refreshHasTalentsData(res);
    } catch (err) {
      notify('Operación no se completo correctamente')
      setIsSending(false);
      return;
    }
    SetOperationSuccess(opeationSuccess + 1);
    setIsSending(false);

    const route = guardarYContinuar ? "/knowledgeAndSkillsModule" : "/talents";
    history.push({
      pathname: route,
      state: {
        updateUserData: true,
      },
    });
  };

  const onGuardarYContinuar = () => {
    formRef.current.validateForm().then((err) => {
      let errors = err?.personaTalentos?.filter((x) => x !== undefined);
      if (errors === undefined || errors.length === 0) {
        setguardarYContinuar(true);
        formRef.current.handleSubmit();
      }
    });
  };

  const onGuardar = () => {
    formRef.current.validateForm().then((err) => {
      let errors = err?.personaTalentos?.filter((x) => x !== undefined);
      if (errors === undefined || errors.length === 0) {
        setguardarYContinuar(false);
        formRef.current.handleSubmit();
      }
    });
  };

  const onCancelar = () => {
    history.push({
      pathname: "/talents",
      state: {
        updateUserData: true,
      },
    });
  };

  const esEditable = (talentoId) => {
    const talento = talentos.find((x) => x.id == talentoId);
    return talento?.editable;
  };

  return (
    <>
      <ToastContainer />
      {isSending && (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Bootstrap.Spinner
            animation="grow"
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            size="lg"
          />
        </div>
      )}
      <Bootstrap.Card>
        <Bootstrap.Card.Body className={"p-40"}>
          <Formik
            innerRef={formRef}
            initialValues={{
              personaTalentos: [
                ..._personaTalentos,
                { id: 0, talentoId: 0, valoracion: 1, descripcion: "", personaId: user.persona.id, estado: 1 },
              ],
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              values,
              touched,
              errors,
              setFieldValue,
            }) => (
              <Form style={{ width: "100%" }}>
                <Bootstrap.Form.Row style={{ width: "100%" }}>
                  <FormHeader />
                  <FieldArray
                    name="personaTalentos"
                    render={(arrayHelpers) => (
                      <div className="col-12">
                        {values.personaTalentos.map((talento, index) => (
                          <div key={index} className="row col-12">
                            <InputTalento index={index} errors={errors} touched={touched} setFieldValue={setFieldValue} talentos={talentos} esEditable={esEditable} />

                            <InputValoracion index={index} setFieldValue={setFieldValue} values={values} />

                            <InputDescripcion index={index} errors={errors} touched={touched} esEditable={esEditable} talento={talento} />

                            <BotonTrash onClick={() => arrayHelpers.remove(index)} />
                          </div>
                        ))}
                        <BotonAgregar onClick={() =>
                          arrayHelpers.push({
                            id: 0,
                            talentoId: 0,
                            valoracion: 1,
                            descripcion: "",
                            personaId: user.persona.id,
                            estado: 1
                          })
                        } />

                        <GrupoBotonesFlujo personaTalentos={_personaTalentos} onCancelar={onCancelar} onGuardar={onGuardar} onGuardarYContinuar={onGuardarYContinuar} />
                      </div>
                    )}
                  />
                </Bootstrap.Form.Row>
              </Form>
            )}
          </Formik>
        </Bootstrap.Card.Body>
      </Bootstrap.Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    opeationSuccess: state.opeationSuccess,
    hasTalentsDataReducer: state.hasTalentsDataReducer
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    SetHasTalentsData: (value) => dispatch(SetHasTalentsData(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TalentoForm);